import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { CAMPAIGN_LIST_KEY } from 'modules/campaigns/constants/common/campaigns.queries';
import EmailCampaignService from 'modules/campaigns/services/email-campaign.service';
import { useTranslationLanguage } from 'contexts/TranslationContext';
import { CAMPAIGN_TYPE_ENUM } from 'modules/campaigns/constants';
import { useCallback } from 'react';
import BannerCampaignService from 'modules/campaigns/services/banner-campaign.service';
import PromotionCampaignService from 'modules/campaigns/services/promotion-campaign.service';

export const useDeleteCampaign = (id: string, type?: CAMPAIGN_TYPE_ENUM, onClose?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('campaigns');
  const { data: locale } = useTranslationLanguage();

  const deleteFn = useCallback(() => {
    switch (type) {
      case CAMPAIGN_TYPE_ENUM.email:
        return EmailCampaignService.delete(id);
      case CAMPAIGN_TYPE_ENUM.banner:
        return BannerCampaignService.delete(id);
      case CAMPAIGN_TYPE_ENUM.itemsPromotion:
        return PromotionCampaignService.delete(id);
      default:
        return Promise.reject(new Error('Invalid campaign type'));
    }
  }, [type, id]);

  return useMutation(deleteFn, {
    onSuccess: (_data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries([locale, CAMPAIGN_LIST_KEY]);
      queryClient.invalidateQueries([id]);
    },
  });
};
